import EzloMobile from './EzloMobile';

export default EzloMobile;
